import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../../../services/api';
import Modal from '../../../../components/shared/Modal';
import { Search } from 'lucide-react';

const fetchEventTypes = async () => (await api.get('/agenda/tipos-de-evento')).data.data;

export default function AddEventTypeModal({ isOpen, onClose, onAdd }) {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: eventTypes, isLoading } = useQuery({
    queryKey: ['allEventTypes'],
    queryFn: fetchEventTypes,
    enabled: isOpen
  });

  const filteredTypes = eventTypes?.filter(type => 
    type.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    type.slug.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Associar Tipo de Evento" size="md">
      <div className="space-y-4">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Pesquisar tipos de evento..."
            className="pl-10 w-full border border-gray-300 rounded-md py-2 px-3 text-sm focus:outline-none focus:ring-primary focus:border-primary"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="max-h-64 overflow-y-auto space-y-2">
          {isLoading && <p className="text-center py-4">Carregando tipos de evento...</p>}
          {filteredTypes?.map(type => (
            <div key={type.id} className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50 transition-colors">
              <div>
                <p className="text-sm font-medium text-gray-900">{type.nome}</p>
                <p className="text-xs text-gray-500">{type.duracao} min — /{type.slug}</p>
              </div>
              <button
                onClick={() => onAdd(type.id)}
                className="bg-primary text-white px-3 py-1 rounded text-xs hover:bg-secondary transition-colors"
              >
                Associar
              </button>
            </div>
          ))}
          {!isLoading && filteredTypes?.length === 0 && (
            <p className="text-center py-4 text-gray-500">Nenhum tipo de evento encontrado.</p>
          )}
        </div>
      </div>
    </Modal>
  );
}
